import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { initLenis, lenis, scrollTo } from './lenis'
import { initAlpine } from './alpine'
import { splitType } from './splitType'
import { navigation } from './navigation'
import { swiper } from './swiper'
import { article } from './article'
import { animation } from './animation'
import { initSolutionsPin } from './solutionsPin'
import { preloader } from './preloader'
import { accordion } from './accordion'
import { isSafariBrowser } from './utilities'
import { cookieBanner } from './cookieBanner'
import { initGoogleMaps } from './map'
import { setTab, navigateTab } from './subNavTabs'
import { anchorLinks } from './anchorLinks'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {

	const container = document.querySelector('[data-load="container"]')
	const namespace = container.dataset.loadNamespace

	if (namespace == 'about' || namespace == 'landing-page-video') {
		document.body.setAttribute('data-invert-header', true)
	} else {
		document.body.setAttribute('data-invert-header', false)
	}
	setTimeout(() => {
		document.body.classList.add('preloader')
		preloader()
	}, 200)

	setTimeout(() => {
		document.body.classList.add('once')
		container.classList.add('ready')
	}, 150)

	cookieBanner()
	initLenis()
	navigation()
	initAlpine()
	splitType()
	swiper()
	accordion()
	scrollTo()
	initSolutionsPin()
	setTab(container)
	article()
	setTimeout(() => animation(), 2600)
	initGoogleMaps()
	anchorLinks()

	if (isSafariBrowser()) {
		document.documentElement.classList.add('is-safari-browser')
	}

	return

	barba.init({
		debug: true,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				once(data) {
					if (data.next.namespace == 'about') {
						document.body.setAttribute('data-invert-header', true)
					} else {
						document.body.setAttribute('data-invert-header', false)
					}
					setTimeout(() => {
						document.body.classList.add('preloader')
						preloader()
					}, 200)
					setTimeout(() => {
						document.body.classList.add('once')
						data.next.container.classList.add('ready')
					}, 150)
				},
				leave(data) {
					if (data.trigger != 'back' && data.trigger.hasAttribute('data-sub-nav-item')) navigateTab(data.current.container, data.trigger)
					document.body.removeAttribute('data-navigation-status')
					document.body.setAttribute('data-current-submenu', 'none')
					return gsap.to(data.current.container, { opacity: 0 })
				},
				enter(data) {
					lenis.scrollTo(0, { immediate: true })
					if (data.next.namespace == 'about') {
						document.body.setAttribute('data-invert-header', true)
					} else {
						document.body.setAttribute('data-invert-header', false)
					}
					data.next.container.classList.add('ready')
					// return gsap.fromTo(data.next.container, { opacity: 0, })
					return
				},
				after(data) { }
			}
		]
	})

	barba.hooks.once((data) => {
		cookieBanner()
		initLenis()
		navigation()
		initAlpine()
		splitType()
		swiper()
		accordion()
		scrollTo()
		initSolutionsPin()
		setTab(data.next.container)
		article()
		setTimeout(() => animation(), 2600)
		initGoogleMaps()

		if (isSafariBrowser()) {
			document.documentElement.classList.add('is-safari-browser')
		}
	})

	barba.hooks.afterLeave((data) => {
		ScrollTrigger.killAll()
	})

	barba.hooks.enter((data) => {
		htmx.process(data.next.container)
	})

	barba.hooks.after((data) => {
		splitType()
		animation()
		swiper()
		initSolutionsPin()
		accordion()
		scrollTo()
		setTab(data.next.container)
		article()
		initGoogleMaps()

		const scripts = document.querySelectorAll('main script')
		scripts.forEach((script) => eval(script.innerHTML))
	})
}

export default initBarba
